import React from 'react';
import Lottie from 'lottie-react';

import loading_app_icon from '../assets/animations/app_logo.json';

function Loading() {
    return (
        <div className="flex flex-col justify-center items-center h-screen bg-white">
            <Lottie 
                animationData={loading_app_icon} 
                loop 
                className="w-48 h-48"
            />
        </div>
    );
}

export default Loading;